import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { Arbeit, Legierung, Material } from "../../types/produktkalkulation";
import { Modal, Validators } from "@softline/ui-core";
import { DynamicModule, FieldOkResultConverter } from "@softline/dynamic";
import { FormControl, FormGroup, ReactiveFormsModule } from "@angular/forms";
import { Artikel } from "@softline/application";

import { NumberInputComponent,
  ValueConverterDirective} from '@softline/ui-core';
@Component({
    selector: 'soft-arbeit-dialog',
    imports: [DynamicModule, ReactiveFormsModule,
    NumberInputComponent,
    ValueConverterDirective
  ],
    templateUrl: './arbeit.dialog.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./arbeit.dialog.css']
})
export class ArbeitDialog implements OnInit, Modal<Partial<Arbeit>> {

  artikelConverter = new FieldOkResultConverter({id: 'id', cartikelnummer: 'nummer', artbez1: 'artbez1'}, {mapKeysOnly: true});

  form = new FormGroup({
    artikel: new FormControl<Artikel | null>(null, [Validators.required()]),
    menge: new FormControl<number | null>(null, [Validators.required()]),
    aufschlagArtikelgruppe: new FormControl<number | null>(null) });

  mode: 'add' | 'edit' = 'add';

  set value(value: Material) {
    this.form.patchValue({
      artikel: value?.artikel,
      menge: +(value?.menge) || null,
      aufschlagArtikelgruppe: value?.aufschlagArtikelgruppeDetailverkauf?.aufschlag ?? null
    });
    this.mode = 'edit';
  }

  close!: (result: Partial<Arbeit>) => void;

  constructor() { }

  ngOnInit(): void {
  }

  registerCloseHandler(handler: (result: Partial<Arbeit>) => void): void {
    this.close = handler;
  }

  onSubmit(): void {
    if(this.form.invalid)
      return;

    const formValue = this.form.getRawValue()

    const value: Partial<Arbeit> = {
      artikel: formValue.artikel ?? undefined,
      menge: formValue.menge + '',
      aufschlagArtikelgruppeDetailverkauf: {
        aufschlag: formValue.aufschlagArtikelgruppe ?? undefined } }

    this.close(value);
  }
}
